import { Copyright } from 'iconsax-react';
import Center from '../../../../assets/styles/Center';
import Text from '../../../../assets/styles/Text';
import * as styles from './styles';

export default function Bottom() {
  return (
    <styles.Bottom>
      <Center>
        <div className="copy">
          <Text.Span>Copyright 2025</Text.Span>
          <Copyright />
          <Text.Span $bold>Flame Hot</Text.Span>
        </div>

        <div className="copy">
          <Text.Span $bold>CNPJ</Text.Span>
          <Text.Span>41.015.753/0001-58</Text.Span>
        </div>
      </Center>
    </styles.Bottom>
  );
}
